module.exports = __webpack_public_path__ + "assets/img/logo.3c2bb13c.png";